var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#unionpayCardProcessingModal .modal-body[data-v-71f135a2] {\n  height: 75vh;\n  overflow-y: auto;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Pay",
  props: ["callback_url", "request_type", "return_url"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      base_url: "",
      total_amount: 0,
      shortcode: null,
      gateway: null,
      stkOpen: false,
      stk_phone: null,
      show_uba_content: false,
      hide_proceed: false,
      initiating: false,
      iframe: null,
      iframeDoc: null,
      html: "",
      error: null
    };
  },

  computed: {
    valid_phone: function valid_phone() {
      if (this.stk_phone) {
        if (this.stk_phone.match(/\d{9}/g)) {
          return true;
        }
      }
      return false;
    }
  },
  mounted: function mounted() {
    window.jQuery = _jquery2.default;
    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.shortcode = this.$attrs["shortcode"];
    this.gateway = this.$attrs["gid"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.base_url = this.$attrs["base_url"];
    this.set_total_amount();
  },
  methods: {
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    toggleStkOpen: function toggleStkOpen() {
      if (this.stkOpen) {
        this.stkOpen = false;
      } else {
        this.stkOpen = true;
      }
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    stk_menu: function stk_menu() {
      var _this = this;

      this.initiating = true;
      var urlIs = this.base_url + "/api/payment/uba/checkout";
      var api_headers = {
        Authorization: "****"
      };
      var params = {
        invoice_number: this.invoice_number,
        gateway_id: this.gateway,
        amount: this.total_amount,
        callback_url: this.callback_url,
        return_url: this.return_url
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _this.initiating = false;
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Request Failed (422). Try Later or Pay Directly to the bank"
          });
        } else {
          _this.initiating = false;
          $("#ubaProcessingModal .close").click();
          _this.load_uba_content(response.data.html);
        }
      }).catch(function (error) {
        _this.initiating = false;
        _this.show_uba_content = false;
        _this.hide_proceed = false;
        $("#ubaCardProcessingModal").hide();
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Request Failed. Try Later or Pay Directly to the bank"
        });
      }).then(function () {
        _this.initiating != true;
        _this.stk_phone = null;
      });
    },
    load_uba_content: function load_uba_content(winHtml) {
      window.top.location.href = URL.createObjectURL(new Blob([winHtml], { type: "text/html" }));
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"ubaProcessingModal","tabindex":"-1","role":"dialog","aria-labelledby":"ubaModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using UBA")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.formatNumber(_vm.total_amount)))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.toggleStkOpen()}}},[_vm._v("Click here to proceed")]),_vm._v(" "),(_vm.stkOpen)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('label',[_vm._v("Phone Number\n                        "),(!_vm.valid_phone)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("* required")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stk_phone),expression:"stk_phone"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Enter a valid phone number e.g 09.."},domProps:{"value":(_vm.stk_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stk_phone=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.valid_phone)?_c('div',{staticClass:"row"},[(_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary"},[_c('span',{staticClass:"spinner-grow spinner-grow-sm"}),_vm._v("\n                        Processing ...\n                      ")]):_vm._e(),_vm._v(" "),(!_vm.initiating)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":_vm.stk_menu}},[_vm._v("\n                        Initiate Payment\n                      ")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(1)])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n                    card-footer\n                    d-flex\n                    justify-content-end\n                    align-items-center\n                  "},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")])])}]
__vue__options__._scopeId = "data-v-71f135a2"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71f135a2", __vue__options__)
  } else {
    hotAPI.reload("data-v-71f135a2", __vue__options__)
  }
})()}